import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import GameAdminSmartCheckInForm from "./GameAdminSmartCheckInForm";
import Container from "@material-ui/core/Container";

const Transition = React.forwardRef(function Transition(
  props,
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function GameAdminSmartCheckIn({
  renderButton,
  renderSecondButton,
  game,
  gameRef,
  ticketReservations,
}) {
  const [open, setOpen] = React.useState(false);
  const [keepOpen, setKeepOpen] = React.useState(false);
  const [step, setStep] = React.useState(1);

  const handleClickOpen = (step = 1) => {
    setStep(step);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      {renderButton(handleClickOpen)}
      {renderSecondButton(handleClickOpen)}
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        maxWidth="sm"
      >
        <Toolbar style={{ marginTop: "env(safe-area-inset-top)" }}>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <Container maxWidth="sm">
          <GameAdminSmartCheckInForm
            gameRef={gameRef}
            game={game}
            ticketReservations={ticketReservations}
            handleClose={handleClose}
            keepOpen={keepOpen}
            setKeepOpen={setKeepOpen}
            step={step}
            setStep={setStep}
          />
        </Container>
      </Dialog>
    </>
  );
}

export default GameAdminSmartCheckIn;
